import { Children, cloneElement } from 'react';

import { useAnchorElContext } from './AnchorElementProvider';

import type { FC, ReactNode } from 'react';

export interface AnchorElementProps {
  children: ReactNode;
}

export const AnchorElement: FC<AnchorElementProps> = ({ children }) => {
  const { onClick } = useAnchorElContext();

  return (
    <>{Children.map(children, (child) => cloneElement(child, { onClick }))}</>
  );
};
